import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import DairyQuery from '~/QueryHooks/DairyQuery'
import Layout from '~/components/Layout'
import TypeCard from '~/components/TypeCard'

const TransportTariffs: React.FC = () => {
  const { t } = useTranslation()
  const {
    isLoading: isBusyData,
    data: transportTariffs,
    refetch: fetchData
  } = DairyQuery.getTransportTariffsList()

  useEffect(() => {
    fetchData()
  }, [t])

  const { rows } = transportTariffs ? transportTariffs : { rows: [] }

  return (
    <Layout
      title={t('Transport Tariffs')}
      isBusy={isBusyData}
      childContainerSize={'auto'}
      fontSizeHeader={'18px'}
      useSpinner
    >
      <TypeCard rows={rows} />
    </Layout>
  )
}
export default TransportTariffs
